import type { SearchResponse } from '@algolia/client-search';
import { RefObject } from 'react';

import { ApiJobId } from 'api/types/ApiTypedId';
import { SearchAlgoliaHit } from 'modules/search/algolia/types/SearchAlgoliaHit';
import { SearchLoadingSectionMockResults } from 'modules/search/components/Loading/SearchLoadingSectionMockResults';
import { SearchContextHeaderData } from 'modules/search/containers/SearchContextHeader/SearchContextHeaderData';

import { ViewJobPageSidebarPaginationHolder } from './ViewJobPageSidebarPagination.styled';
import { ViewJobPageSidebarPaginationHits } from './ViewJobPageSidebarPaginationHits';

type Props = {
  jobId: ApiJobId;
  results: SearchResponse<SearchAlgoliaHit> | undefined;
  searchContext: SearchContextHeaderData;
  scrollingParentRef: RefObject<HTMLElement | null>;
};

export function ViewJobPageSidebarPagination({
  results,
  jobId,
  searchContext,
  scrollingParentRef,
}: Props) {
  return (
    <ViewJobPageSidebarPaginationHolder>
      {results ? (
        <ViewJobPageSidebarPaginationHits
          selectedJobId={jobId}
          selectedJobPage={results.page}
          queryID={results.queryID}
          selectedJobPageHits={results.hits}
          totalPages={results.nbPages}
          searchContext={searchContext}
          scrollingParentRef={scrollingParentRef}
        />
      ) : (
        <SearchLoadingSectionMockResults items={3} />
      )}
    </ViewJobPageSidebarPaginationHolder>
  );
}
